import { render } from "./DoctorEndChat.vue?vue&type=template&id=0975a989&scoped=true"
import script from "./DoctorEndChat.vue?vue&type=script&lang=js"
export * from "./DoctorEndChat.vue?vue&type=script&lang=js"

import "./DoctorEndChat.vue?vue&type=style&index=0&id=0975a989&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0975a989"

export default script